import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS
import "./src/styles/global.css"; // Tailwind

// Load Bootstrap JS only on client side
if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap.bundle.min.js");
}

// Handle client-side routing for SSG
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Ensure proper routing on client-side
  if (typeof window !== "undefined") {
    const currentPath = window.location.pathname;
    const gatsbyPath = location.pathname;
    
    // If there's a mismatch, log it for debugging
    if (currentPath !== gatsbyPath) {
      console.log('Route mismatch detected:', { currentPath, gatsbyPath });
    }
  }
};

// Handle initial route load
export const onInitialClientRender = () => {
  if (typeof window !== "undefined") {
    const currentPath = window.location.pathname;
    console.log('Initial client render for path:', currentPath);
  }
};

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.state && location.state.preventScroll === true) {
    return false;
  }

  if (location.hash) {
    window.history.scrollRestoration = 'auto';
    return true;
  }

  window.history.scrollRestoration = 'manual'
  const currentPosition = getSavedScrollPosition(location, location.key);
  const top = currentPosition ? currentPosition[1] : 0;

  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      try {
        window.scrollTo({ top, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(top);
      }
    });
  }, 0);
  return false;
}